import { render, staticRenderFns } from "./addRole.vue?vue&type=template&id=2363e2ad&scoped=true&"
import script from "./addRole.vue?vue&type=script&lang=js&"
export * from "./addRole.vue?vue&type=script&lang=js&"
import style0 from "./addRole.vue?vue&type=style&index=0&id=2363e2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363e2ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2363e2ad')) {
      api.createRecord('2363e2ad', component.options)
    } else {
      api.reload('2363e2ad', component.options)
    }
    module.hot.accept("./addRole.vue?vue&type=template&id=2363e2ad&scoped=true&", function () {
      api.rerender('2363e2ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/roles/components/addRole.vue"
export default component.exports